import { Box, Typography, Button, List, ListItem } from "@mui/material";
import { Link } from "react-router-dom";
import "./ourServices.scss";
import "../App.scss";

export default function OurServices({listOfServices}){    
    return(
        <Box id='ourPassion' className='container' sx={{height: '100vh'}}>
            <Box className='flex-center-col'>
                <Typography component={'h3'} variant="h4" fontWeight={600}>Our Passion</Typography>
                <Typography component={'p'} variant="p">
                    We are passionate about crafting unique and captivating online experiences that perfectly align with 
                    your vision and business goals. With a team of skilled designers and developers, we take pride 
                    in creating visually stunning, user-friendly, and fully responsive websites that leave a lasting 
                    impression on your visitors. Whether you're a small business looking to establish a strong online 
                    presence or an established brand seeking a website revamp, we tailor our services to meet 
                    your specific needs. Let us bring your dream website to life!
                </Typography>
                <Typography component={'h3'} fontSize='1.7rem' fontWeight={500}>What We Offer</Typography>
                <List sx={{ width: '100%', maxWidth: 360, m: '1rem 0'}}>
                    {listOfServices.map((listItem) => {
                        return(
                            <ListItem key={listItem.id} divider={true} sx={{bgcolor: '#206BA3', justifyContent: 'center'}}>{listItem.title}</ListItem>
                        )
                    })}
                </List>
                <Link to="/services" style={{ textDecoration: 'none'}}>
                    <Button component={"button"} variant='contained' sx={{ width: "150px"}}>Learn More</Button>
                </Link>
            </Box>
        </Box>
    )
}